import { useLocation, useNavigate } from 'react-router-dom';
import { IntlIcon } from '@/components/IntlIcon';
import { Button } from '@/components/ui/button';

export const GHOST_BUTTON_LABEL_CLASS =
  'text-[14px] leading-5 font-medium uppercase text-black';

export function BackButton({
  onClick,
  label = 'Back',
}: {
  onClick: () => void;
  label?: string;
}) {
  return (
    <Button
      type="button"
      variant="ghost"
      onClick={onClick}
      className={`h-8 gap-2 rounded-md px-4 py-2.5 ${GHOST_BUTTON_LABEL_CLASS}`}
    >
      <IntlIcon name="arrow-left" className="h-4 w-4" />
      {label}
    </Button>
  );
}

const FIRST_PAGE_OPENED = 'default';

export function PreviousPageButton() {
  const navigate = useNavigate();
  const { key } = useLocation();

  return key === FIRST_PAGE_OPENED ? null : (
    <div className="px-6 py-3">
      <BackButton onClick={() => navigate(-1)} />
    </div>
  );
}
